import { RulesetEnum } from '../enums/RulesetEnum';
import { RegionsEnum } from '../enums/RegionsEnum';
import { SVTEnum } from './SVTEnum';
import { PatternEnum } from './PatternEnum';

const OCCO = [
    'Open/close',
    'On/off',
    'Changeover',
];

function guessRulesetEU(
    type: string,
    pattern: string,
    operationMode: string,
): RulesetEnum | null {
    switch (true) {
        // PI
        case type === SVTEnum.PIQCV && pattern !== PatternEnum['6-way']: {
            return RulesetEnum.Ruleset4_PIQCV;
        }
        case type === SVTEnum['6-way PIQCV']:
        case type === SVTEnum['6-way EPIV']: {
            return RulesetEnum.Ruleset6_PI_6W_EPIV;
        }

        case type === SVTEnum.EV:
        case type === SVTEnum.EPIV: {
            return RulesetEnum.Ruleset3_PI_EV_EPIV;
        }
        case type === SVTEnum.PIFLV: {
            return RulesetEnum.Ruleset100_PIFLV;
        }
        //PD
        case type === SVTEnum['6-way QCV']:
        case type === SVTEnum['6-way CCV']: {
            return RulesetEnum.Ruleset5_PD_6W;
        }
        case 'Changeover' === operationMode && type === SVTEnum.GV && pattern === PatternEnum['3-way']: {
            return RulesetEnum.Ruleset1_PD_GV_3W_CO;
        }
        case OCCO.includes(operationMode): {
            return RulesetEnum.Ruleset1_PD_OCCO;
        }
        case type === SVTEnum.GV: {
            return RulesetEnum.Ruleset1_PD_GV;
        }
        case type === SVTEnum.BFV:
        case type === SVTEnum.CV:
        case type === SVTEnum.BV:
        case type === SVTEnum.CCV:
        case type === SVTEnum.HTCCV: {
            return RulesetEnum.Ruleset1_PD;
        }
        case type === SVTEnum.ZV:
        case type === SVTEnum.QCV: {
            return RulesetEnum.Ruleset1_PD_QCV;
        }
        default:
            return null;
    }
}

function guessRulesetAM(
    type: string,
    _: string,
    operationMode: string,
): RulesetEnum | null {
    switch (true) {
        case type === SVTEnum.BFV && OCCO.includes(operationMode): {
            return RulesetEnum.AM_PD_BFV_OC;
        }
        case type === SVTEnum.BFV: {
            return RulesetEnum.AM_PD_BFV;
        }
        case type === SVTEnum.GV:
        case type === SVTEnum.CV:
        case type === SVTEnum.BV:
        case type === SVTEnum.CCV:
        case type === SVTEnum.ZV:
        case type === SVTEnum.HTCCV: {
            return RulesetEnum.AM_PD;
        }
        case type === SVTEnum.QCV: {
            return RulesetEnum.AM_PD_QCV;
        }
        case type === SVTEnum['6-way QCV']:
        case type === SVTEnum['6-way CCV']: {
            return RulesetEnum.AM_PD_6W_CCV;
        }
        // PI
        case type === SVTEnum['6-way EPIV']: {
            return RulesetEnum.AM_PI_6W;
        }
        case type === SVTEnum.PIQCV:
        case type === SVTEnum.PICCV:
        case type === SVTEnum.EV:
        case type === SVTEnum.EPIV:
        case type === SVTEnum.PIFLV: {
            return RulesetEnum.AM_PI;
        }
        default:
            return null;
    }
}

export function guessRulesets(
    currentRegion: RegionsEnum,
    types: string[],
    patterns: string[],
    operationModes: string[],
): RulesetEnum[] {
    const out: Set<RulesetEnum> = new Set<RulesetEnum>();
    for (const type of types) {
        for (const pattern of patterns) {
            if (operationModes.length === 0) {
                const ruleset = currentRegion === RegionsEnum.am
                    ? guessRulesetAM(type, pattern, '') : guessRulesetEU(type, pattern, '');
                if (ruleset) {
                    out.add(ruleset);
                }
            } else {
                for (const operationMode of operationModes) {
                    const ruleset = currentRegion === RegionsEnum.am
                        ? guessRulesetAM(type, pattern, operationMode) : guessRulesetEU(type, pattern, operationMode);
                    if (ruleset) {
                        out.add(ruleset);
                    }
                }
            }
        }
    }
    return [...out.values()];
}
